import React from "react";
import { Route } from "react-router-dom";
import { HomePage } from "../../Pages/HomePage/HomePage";
import { Regulations } from "../../Pages/PageRegulations/PageRegulations";

export const Main = (props) => {
  return (
    <div className="main_section">
      <Route exact path="/">
        <HomePage />
      </Route>
      <Route path="/regulations">
        <Regulations />
      </Route>
      <Route path="/commission">
        <div>PageCommission</div>
      </Route>
      <Route path="/DistributionCoins">
        <div>Page Distribution of coins</div>
      </Route>
      <Route path="/LotteryHistory">
        <div>Page Lottery history</div>
      </Route>
      <Route path="/CheckHash">
        <div>Page Check Hash</div>
      </Route>
    </div>
  );
};
